export const RO_SIGNIN = "/signin";
export const RO_INSTITUTION_PAGE = "/institution";